import { Navigate, useLocation } from "react-router-dom";
import { useSessionStore } from "@/store/session.store";

function RequireSession({ children }) {
  const user = useSessionStore((s) => s.user);
  const ensureSessionValid = useSessionStore((s) => s.ensureSessionValid);
  const location = useLocation();
  const valid = ensureSessionValid();
  if (!user || !valid) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
export { RequireSession as default };
